exports = module.exports = require("../../../../../../../../../../../../../tools/web-builder/node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".vertical-tile-displays-4zs{padding:9px 15px 10px 23px}", "",{"version":3,"sources":["display.scss"],"names":[],"mappings":"AACA,4BACE,0BAAA","file":"display.scss","sourcesContent":["\r\n.vertical-tile-displays-4zs {\r\n  padding: 9px 15px 10px 23px;\r\n}"]}]);

